import React from 'react';

const PushpinIcon = class extends React.Component {
	render() {
		return (
			<svg fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style={this.props.style||{}}>
				<path d="M10.67151,19.32849l2,2L8.21759,25.78241a1.99989,1.99989,0,0,1-.45453.34051l-2.66479,1.4574a.5.5,0,0,1-.67865-.67859l1.45746-2.66479a1.99989,1.99989,0,0,1,.34051-.45453Zm17.0564-9.3996L22.071,4.272a2,2,0,1,0-2.82843,2.82843l.50007.50006-3.743,3.74268a3.99968,3.99968,0,0,0-5.65655-.00006L8.636,13.05023a1,1,0,0,0,0,1.41419l8.89941,8.89972a1,1,0,0,0,1.41425-.00007L20.657,21.65668a3.9998,3.9998,0,0,0-.00024-5.65656l3.74268-3.7428.5.5a2,2,0,1,0,2.82843-2.82843Z"/>
			</svg>
		);
	}
}

export default PushpinIcon;
